/* eslint-disable no-unused-vars */
export enum Endpoint {
  LocationByGeoposition = '/locations/v1/cities/geoposition/search.json',
  LocationsByIP = '/locations/v1/cities/ipaddress',
  WeatherEvents = '/forecasts/v1/daily/10day/events/stations',
  LifestyleIndices = '/indices/v1/daily/1/stations',
}
